export default "__VITE_ASSET__DUJ317Fe__"